import axios from 'axios';

const DONORS_MANAGE = '/donors/manage/';

export function normalizeDonorsRestrictedResponse(data) {
  let list = data?.results ?? data ?? [];
  if (!Array.isArray(list)) return [];
  if (
    list.length === 1 &&
    Array.isArray(list[0]) &&
    list[0].length &&
    list[0][0] &&
    typeof list[0][0] === 'object' &&
    'id' in list[0][0]
  ) {
    list = list[0];
  }
  return list.filter((item) => item && typeof item === 'object' && 'id' in item);
}

export const getDonors = async (page, entire) => {
  const params = new URLSearchParams();
  if (page) params.set('page', String(page));
  if (entire) params.set('entire', 'true');
  const qs = params.toString();
  const url = `${DONORS_MANAGE}${qs ? `?${qs}` : ''}`;
  const response = await axios.get(url);
  return response;
};

export const setNewDonor = async (body) => {
  const response = await axios.post(DONORS_MANAGE, body);
  return response;
};

export const updateDonor = async (id, body) => {
  const url = `${DONORS_MANAGE}${id}/`;
  const response = await axios.patch(url, body);
  return response;
};

const donorsRestrictedPromiseByOrg = new Map();
const donorByIdPromise = new Map();

export const getDonorsRestricted = async (organizationId) => {
  const key = organizationId ?? 'default';
  if (donorsRestrictedPromiseByOrg.has(key)) return donorsRestrictedPromiseByOrg.get(key);

  const params = new URLSearchParams();
  if (organizationId) params.set('organization', String(organizationId));
  const query = params.toString();
  const url = query ? `/donors/restricted/?${query}` : '/donors/restricted/';

  const request = axios
    .get(url)
    .then((res) => {
      donorsRestrictedPromiseByOrg.delete(key);
      return {
        ...res,
        data: normalizeDonorsRestrictedResponse(res.data),
      };
    })
    .catch((err) => {
      donorsRestrictedPromiseByOrg.delete(key);
      throw err;
    });

  donorsRestrictedPromiseByOrg.set(key, request);
  return request;
};

/** @deprecated Use getDonorsRestricted for org-scoped list. */
export const getDonorsNames = getDonorsRestricted;

export const getDonorById = async (id) => {
  if (!id) return Promise.resolve({ data: null });
  if (donorByIdPromise.has(id)) return donorByIdPromise.get(id);

  const url = `${DONORS_MANAGE}${id}/`;
  const request = axios
    .get(url)
    .then((res) => {
      donorByIdPromise.delete(id);
      return res;
    })
    .catch((err) => {
      donorByIdPromise.delete(id);
      throw err;
    });

  donorByIdPromise.set(id, request);
  return request;
};
